// convert input to uppercase leaving nullish values untouched
export const toUpper = (value: any) => {
    return value?.toString()?.toUpperCase() || value;
};
